document.addEventListener('DOMContentLoaded', function() {
  console.log("asd")
  const body = document.querySelector('body');
  


  const getCurrencySymbol = () => {
  // Try to get it from Shopify's money format
  if (window.theme && window.theme.moneyFormat) {
    return window.theme.moneyFormat.replace('{{amount}}', '').trim();
  }
  // Fallback to shekel for Israel
  return '₪';
};


  body.addEventListener('click', function(event) {
  console.log("qwe")
    // Check if the clicked element is a swatch inside a product card
    if (event.target && event.target.classList.contains('product-card-swatch')) {
      
      const swatch = event.target;
      const productCard = swatch.closest('.card__container');
      
      if (productCard) {
        let mediaImages = productCard.querySelectorAll('img.card__img');
        let productTitle = swatch.dataset.productHandle;
        const productTitleElements = productCard.querySelectorAll('h3.card__title');
        let actualPrice = productCard.querySelector('.price-item--regular');
        var quickBuyModal = productCard.querySelector('quick-buy-modal');
        const featuredMedia = productCard.querySelectorAll('.card__picture');
        const hoverImage  = productCard.querySelectorAll('.card__picture');

        
        // Remove 'active' class from all swatches
        productCard.querySelectorAll('.product-card-swatch').forEach(function(s) {
          s.classList.remove('active');
        });
        // Add 'active' class to the clicked swatch
        swatch.classList.add('active');
        let productUrl = `${window.location.origin}/products/${productTitle}.js`;
        console.log(window.location.origin, 'swatchProduct');
        // Fetch product data
        fetch(productUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
          })
          .then(data => {
            console.log(data);
            // Update product title elements
            if (productTitleElements && data && data.title) {
              productTitleElements.forEach((element) => {
                element.innerHTML = data.title;
              });
            }
            // Update product URLs in anchors
            productCard.querySelectorAll('a').forEach(function(anchor) {
              anchor.setAttribute('href', data.url);
            });
     if (actualPrice && data && data.compare_at_price) {               
    actualPrice.innerHTML =  ((data.compare_at_price / 100).toFixed(2) + ' ' + getCurrencySymbol() );             
} else if (actualPrice && data && data.price) {               
    actualPrice.innerHTML =  (((data.price / 100).toFixed(2)) +' ' + getCurrencySymbol() );             
} else {}
            if (featuredMedia.length > 0) {
                featuredMedia.forEach(media => {
                    const imageElement = media.querySelector('img');
                    if (imageElement) {
                        imageElement.src = data.featured_image;
                        imageElement.srcset = data.featured_image;
                    } else {
                        console.error('No <img> element found inside featuredMedia.');
                    }
                });
            } else {
                console.error('No elements found with the class .product__media__image.');
            }
            if (hoverImage.length > 0) {
              hoverImage.forEach(media => {
                  const imageElement = media.querySelector('img');
                  if (imageElement) {
                      imageElement.src = data.images[0];
                      imageElement.srcset = data.images[0];
                  } else {
                      console.error('No <img> element found inside hoverImage.');
                  }
              });
            }
          })
          .catch(error => {
            console.log('There was a problem with the fetch operation:', error);
          });
      }
    }
  });
});